// extracted by mini-css-extract-plugin
export default {"loading-wrap":"style_loading-wrap__5vyV4","img-wrap":"style_img-wrap__oi+NN","glow-bg":"style_glow-bg__itxGM","pulse":"style_pulse__+K-iO"};